/* eslint-disable no-param-reassign */
import { CaseReducer, SliceCaseReducers } from '@reduxjs/toolkit';
import { createSlice } from 'helpers/createSlice';
import { fromEntries } from 'helpers/general';
import { getErrorMessage } from 'helpers/toast';
import * as allFeatures from 'store/features';
import { ActionWithPayload, ApiError, ToastMessage } from 'types';

const {
  authSignIn: omitted1, // eslint-disable-line
  ...featuresToFail
} = allFeatures;

type State = Array<ToastMessage>;

interface Reducers extends SliceCaseReducers<State> {
  push: CaseReducer<State, ActionWithPayload<ToastMessage>>;
  removeFirst: CaseReducer<State>;
  reset: CaseReducer<State>;
}

const initialState: State = [];

const genericFailureReducer: CaseReducer<State, ActionWithPayload<ApiError>> = (
  state,
  { payload: error }
) => {
  state.push(getErrorMessage(undefined, error.message));
};

export const toast = createSlice<State, Reducers>({
  name: 'toast',
  initialState,
  reducers: {
    reset: () => initialState,
    removeFirst: (state) => {
      state.shift();
    },
    push: (state, { payload }) => {
      state.push(payload);
    },
  },
  extraReducers: {
    ...fromEntries(
      Object.values(featuresToFail)
        .filter((feature) => feature.actions.failed)
        .map((rs) => [rs.actions.failed.type, genericFailureReducer])
    ),
  },
});
